// extracted by mini-css-extract-plugin
module.exports = {"navbar-logo":"style_navbar-logo__1Rmi7","con":"style_con__3Lc2W"};